<template>
  <div class="amap-page-container" v-if="is_show">
    <div id="container" style="width:100%;height:300px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_show:false,
    };
  },
  created() {
    // 配置
  },
  mounted() {


  },
  methods: {
    open(start,end) {
      this.is_show=true;
      this.$nextTick(() => {
          var map = new AMap.Map("container", {
              // center: [116.397559, 39.89621],
               zoom: 14
           });

           var drivingOption = {
               policy: AMap.DrivingPolicy.LEAST_TIME, // 其它policy参数请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingPolicy
             /*  ferry: 1, // 是否可以使用轮渡
               province: '京', // 车牌省份的汉字缩写 */
               map: map,
           }
           // 构造路线导航类
           var driving = new AMap.Driving(drivingOption)

           // 根据起终点经纬度规划驾车导航路线
           driving.search(new AMap.LngLat(start.longitude, start.latitude), new AMap.LngLat(end.longitude, end.latitude), function(status, result) {
               // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
               if (status === 'complete') {
                  // log.success('绘制驾车路线完成')
               } else {
                   //log.error('获取驾车数据失败：' + result)
               }
           });
        });
    }
  }
};
</script>
<style>
.amap-marker-label {
  border: 0px;
  background: rgba(255, 255, 255, 0);
  color: #fff;
  font-size: 17px;
  font-weight: 550;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/gaodeMap.vue